const Monitors = [
    {
        coords: [196,21],
        shape: "circle",
        id: 1
    },
    {
        coords: [146,54],
        shape: "circle",
        id: 2
    },
    {
        coords: [273,163],
        shape: "circle",
        id: 3
    },
    {
        coords: [217,186],
        shape: "circle",
        id: 4
    },
    {
        coords: [296,180],
        shape: "circle",
        id: 5
    },
    {
        coords: [288,199],
        shape: "circle",
        id: 6
    },
    {
        coords: [86,269],
        shape: "circle",
        id: 7
    },
    {
        coords: [99,283],
        shape: "circle",
        id: 8
    },
    {
        coords: [234,285],
        shape: "circle",
        id: 9
    },
    {
        coords: [95,300],
        shape: "circle",
        id: 10
    },

];

export default Monitors;